export default function getFromEnv(key) {
  return process.env[key];
}
